import React from 'react';
import classnames from 'classnames';

import { PageControls } from './page-controls.component';
import { PageLimit } from './page-limit.component';
import { PaginationInfo } from './pagination-info.component';

export type PaginationProps = {
  pageSize: number;
  pageIndex: number;
  totalCount?: number;
  rowsPerPage: number[];
  canPreviousPage: boolean;
  canNextPage: boolean;
  className?: string;
  onPreviousPage: () => void;
  onNextPage: () => void;
  onPageChange: (value: number) => void;
  onPageSizeChange?: (value: number) => void;
};

export const Pagination = ({
  pageSize,
  pageIndex,
  totalCount,
  rowsPerPage,
  canPreviousPage,
  canNextPage,
  className,
  onPreviousPage,
  onNextPage,
  onPageChange,
  onPageSizeChange,
}: PaginationProps) => (
  <div
    className={classnames(
      'flex items-center justify-between w-full',
      className
    )}
  >
    <PageControls
      pageIndex={pageIndex}
      pageSize={pageSize}
      totalCount={totalCount}
      canPreviousPage={canPreviousPage}
      canNextPage={canNextPage}
      onPreviousPage={onPreviousPage}
      onNextPage={onNextPage}
      onPageChange={onPageChange}
    />

    <div className="space-x-2">
      {rowsPerPage.length > 1 && (
        <PageLimit
          pageSize={pageSize}
          rowsPerPage={rowsPerPage}
          onPageSizeChange={onPageSizeChange}
        />
      )}

      {totalCount !== undefined ? (
        <PaginationInfo
          pageSize={pageSize}
          pageIndex={pageIndex}
          totalCount={totalCount}
        />
      ) : null}
    </div>
  </div>
);
